<template>
  <div class="shadow bg-indigo-100 dark:bg-gray-600 rounded p-3 grid grid-cols-2 gap-2 items-center">
       <input-text
            name="label"
            placeholder="Label"
            v-model="row.label"
            @input="updated"
        />
        <Select
            unsettable
            placeholder="Select an Attribute"
            name="key"
            v-model="row.attribute"
            :options="listAttributes"
            @input="updated"
        />

      <media-reference
          v-if="showManualEntryInput"
          name="label-icon"
          v-model="row.data"
          class="col-span-2"
          @input="updated"
          :media-types="['Icon']"
          :language="language"
      />

      <input-rich-text
            v-if="showManualEntryInput"
            name="value"
            @input="updated"
            v-model="row.value"
            class="col-span-2"
            :language="language"
        />

        <rocket-link
            class="col-span-2"
            :language="language"
            :hide-link-text="true"
            :resettable="true"
            v-model="row.link"
        />

    </div>
</template>

<script>
import Attributes from '../../tableSchema/casino';
import siteLanguage from '../../config/siteLanguage'
import RocketLink from "../Link/RocketLink.vue";

export default {
    name: "Row",
    components: {RocketLink},
    props: {
        data: {
            required: true,
            type: Object
        },
        casino: {
            type: Object,
            required: true,
        },
        language: {
            type: Object,
            default: () => {
                return {
                    iso: siteLanguage.iso.ENGLISH,
                    id: siteLanguage.language.ENGLISH,
                };
            },
        },
    },
    data(){
        return {
            row: this.data || {
                attribute: null,
                label: null,
                value: null,
                data: null,
                link: {},
            },
        }
    },
    methods: {
        updated(){
            this.$emit('input', this.row);
        },
    },
    computed:{
        listAttributes(){
            return Attributes.map((attribute) => {
                return {
                    value: attribute.key,
                    name: attribute.name
                }
            })
        },
        showManualEntryInput(){
            return this.row.attribute === "manualEntryText()";
        }
    },
    watch: {
        "row.attribute": function(newValue, oldValue){
            if(oldValue === "manualEntryText()"){
                this.row.value = null;
                this.row.data = null;
                this.updated();
            }
        },
        "row.link": {
            deep: true,
            handler: function (newValue) {
                this.updated();
            },
        },
    }
}
</script>
